import { Injectable, TemplateRef } from '@angular/core';
import * as Rx from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ViewHeaderTemplate {
  private templateRefSubject$ = new Rx.BehaviorSubject<
    TemplateRef<any> | undefined
  >(undefined);

  registerHeader(templateRef: TemplateRef<any>) {
    if (this.templateRefSubject$.value) {
      throw new Error(
        'Could not register view header component: a view header already exists!',
      );
    }
    this.templateRefSubject$.next(templateRef);
  }

  deregisterHeader(templateRef: TemplateRef<any>) {
    if (this.templateRefSubject$.value === templateRef) {
      this.templateRefSubject$.next(undefined);
    }
  }

  templateChanges() {
    return this.templateRefSubject$.asObservable();
  }
}
